(function (app, ng) {
    var appointmentDateStructure = {
        StartDate: "date",
        EndDate: "date"
    };

    function datify(obj, structure) {
        if (!obj) return;
        if (ng.isArray(structure)) {
            for (let i = 0; i < obj.length; i++) {
                if (structure[0] === "date" && ng.isString(obj[i]))
                    obj[i] = new Date(obj[i]);
                if (ng.isObject(structure[0]) || ng.isArray(structure[0]))
                    datify(obj[i], structure[0]);
            }
            return;
        }
        if (ng.isObject(structure)) {
            for (let key in structure) {
                if (!structure.hasOwnProperty(key)) continue;
                if (structure[key] === "date" && ng.isString(obj[key]))
                    obj[key] = new Date(obj[key]);
                if (ng.isObject(structure[key]) || ng.isArray(structure[key]))
                    datify(obj[key], structure[key]);
            }
        }
    }

    app.provider("appointmentApi", [
        function () {
            this.$get = ["crmApiGateway", function (crmApiGateway) {
                const service = {
                    getAppointment: (appointmentId) => {
                        return crmApiGateway.get(`/Appointments/${appointmentId}`).then(response => {
                            datify(response, appointmentDateStructure);
                            return response;
                        });
                    },
                    getAppointments: (nextPageToken, year, month) => {
                        let url = "/Appointments?";

                        if (!!nextPageToken) {
                            url = `${url}&nextPageToken=${nextPageToken}`;
                        }

                        if (!!year && !!month) {
                            url = `${url}&year=${year}&month=${month}`;
                        }

                        return crmApiGateway.getArray(url).then(appointments => {
                            appointments.forEach(appointment => {
                                datify(appointment, appointmentDateStructure);
                            });

                            return appointments;
                        });
                    },
                    getUserAppointments: (userId, nextPageToken, year, month) => {
                        let url = `/Users/${userId}/Appointments?`;

                        if (!!nextPageToken) {
                            url = `${url}&nextPageToken=${nextPageToken}`;
                        }

                        if (!!year && !!month) {
                            url = `${url}&year=${year}&month=${month}`;
                        }

                        return crmApiGateway.getArray(url).then(appointments => {
                            appointments.forEach(appointment => datify(appointment, appointmentDateStructure));

                            return appointments;
                        });
                    },
                    getClientAppointments: (clientId, nextPageToken) => {
                        let url = `/Clients/${clientId}/Appointments?`;

                        if (!!nextPageToken) {
                            url = `${url}&nextPageToken=${nextPageToken}`;
                        }

                        return crmApiGateway.getArray(url).then(appointments => {
                            appointments.forEach(appointment => datify(appointment, appointmentDateStructure));

                            return appointments;
                        });
                    },
                    getAppointmentNotes: (appointmentId) => {
                        return crmApiGateway.getArray(`/Appointments/${appointmentId}/Notes`);
                    },
                    getAppointmentAttendees: (appointmentId) => {
                        return crmApiGateway.getArray(`/Appointments/${appointmentId}/Attendees`);
                    },
                    getAppointmentAssignedUsers: (appointmentId) => {
                        return crmApiGateway.getArray(`/Appointments/${appointmentId}/AssignedUsers`);
                    },
                    getScheduledTasks: (appointmentId) => {
                        return crmApiGateway.getArray(`/Appointments/${appointmentId}/ScheduledTasks`);
                    },
                    updateAppointment: (appointmentId, appointment) => {
                        return crmApiGateway.put(`/Appointments/${appointmentId}`, appointment);
                    },
                    updateAppointmentDetails: (appointmentId, appointment) => {
                        return crmApiGateway.put(`/Appointments/${appointmentId}/AppointmentDetails`, appointment);
                    },
                    updateAppointmentNote: (appointmentId, noteId, note) => {
                        return crmApiGateway.put(`/Appointments/${appointmentId}/Notes/${noteId}`, note);
                    },
                    completeAppointment: (appointmentId) => {
                        return crmApiGateway.put(`/Appointments/${appointmentId}/Complete`);
                    },
                    addAttendee: (appointmentId, clientId) => {
                        return crmApiGateway.put(`/Appointments/${appointmentId}/Attendees/${clientId}`);
                    },
                    addAssignedUser: (appointmentId, userId) => {
                        return crmApiGateway.put(`/Appointments/${appointmentId}/AssignedUsers/${userId}`);
                    },
                    createAppointment: (appointment) => {
                        return crmApiGateway.post("/Appointments", appointment);
                    },
                    addAppointmentNote: (appointmentId, note) => {
                        return crmApiGateway.post(`/Appointments/${appointmentId}/Notes`, note);
                    },
                    deleteAppointment: (appointmentId) => {
                        return crmApiGateway.delete(`/Appointments/${appointmentId}`);
                    },
                    cancelAppointment: (appointmentId) => {
                        return crmApiGateway.delete(`/Appointments/${appointmentId}/Cancel`);
                    },
                    removeAppointmentNote: (appointmentId, noteId) => {
                        return crmApiGateway.delete(`/Appointments/${appointmentId}/Notes/${noteId}`);
                    },
                    removeAttendee: (appointmentId, clientId) => {
                        return crmApiGateway.delete(`/Appointments/${appointmentId}/Attendees/${clientId}`);
                    },
                    removeAssignedUser: (appointmentId, userId) => {
                        return crmApiGateway.delete(`/Appointments/${appointmentId}/AssignedUsers/${userId}/`);
                    }
                };

                return service;
            }];
        }
    ]);
})(window.app, window.angular); // jshint ignore:line